var _style, _defs, _path, _path2, _circle, _circle2, _path3, _path4, _circle3, _path5, _circle4, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg002TotalWater(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: 0,
    y: 0,
    xmlSpace: "preserve",
    width: 833,
    height: 294.096,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style2"
  }, ".st12{fill:#fff}.st77{clip-path:url(#SVGID_18_);fill:#e8eceb}.st751{fill:#9ed5d9}.st752{fill:#a6dedb}.st753{fill:#abe5dd}.st754{fill:#d2fcee}.st755{fill:#f2fefa}.st756{fill:#005067}.st757{fill:#73acaf}.st760{fill:#d5e6e7}.st765{fill:#ea527f}.st766{fill:#c7cee5}.st767{fill:#caebe9}.st768{fill:#cdefeb}.st769{fill:#e4fdf5}.st770{fill:#f7fefc}.st774{fill:#6696a4}.st776{fill:#545e75}")), /*#__PURE__*/React.createElement("g", {
    id: "g272",
    transform: "translate(-864 -322.322)"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs245"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_157_",
    d: "M864 185h833v407H864z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_18_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_157_",
    style: {
      overflow: "visible"
    },
    id: "use247",
    x: 0,
    y: 0,
    width: "100%",
    height: "100%"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st77",
    d: "M1328.875 538.161c-52.831 52.834-52.831 138.497 0 191.33 52.833 52.833 138.495 52.833 191.328 0 52.832-52.833 52.832-138.495 0-191.33-52.833-52.83-138.495-52.83-191.328 0z",
    clipPath: "url(#SVGID_18_)",
    id: "path250"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st77",
    d: "M1566.875 488.161c-52.831 52.834-52.831 138.497 0 191.33 52.833 52.833 138.495 52.833 191.328 0 52.832-52.833 52.832-138.495 0-191.33-52.833-52.83-138.495-52.83-191.328 0z",
    clipPath: "url(#SVGID_18_)",
    id: "path252"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st77",
    cx: 1266.855,
    cy: 587.604,
    r: 44.306,
    clipPath: "url(#SVGID_18_)",
    id: "circle254"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st77",
    cx: 1237.727,
    cy: 613.014,
    r: 44.307,
    clipPath: "url(#SVGID_18_)",
    id: "circle256"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st77",
    d: "M1194.932 558.132c-9.259 9.259-9.259 24.271 0 33.529 9.258 9.26 24.27 9.26 33.529 0 9.258-9.258 9.258-24.27 0-33.529-9.258-9.258-24.27-9.258-33.529 0z",
    clipPath: "url(#SVGID_18_)",
    id: "path258"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st77",
    d: "M1248.991 619.22c-46.337 46.34-46.337 121.47 0 167.808 46.341 46.338 121.47 46.338 167.81 0 46.337-46.338 46.337-121.468 0-167.808-46.34-46.34-121.469-46.34-167.81 0z",
    clipPath: "url(#SVGID_18_)",
    id: "path260"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st77",
    cx: 764.341,
    cy: 482.023,
    r: 128.951,
    clipPath: "url(#SVGID_18_)",
    id: "circle262"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st77",
    d: "M872.942 513.649c-19.225 19.225-19.225 50.394 0 69.619 19.225 19.226 50.394 19.226 69.619 0 19.225-19.224 19.225-50.394 0-69.619-19.224-19.225-50.394-19.225-69.619 0z",
    clipPath: "url(#SVGID_18_)",
    id: "path264"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st77",
    cx: 831.89,
    cy: 653.248,
    r: 103.317,
    clipPath: "url(#SVGID_18_)",
    id: "circle266"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st77",
    d: "M944.361 566.797c-69.676 69.674-69.676 182.637-.002 252.314 69.675 69.675 182.638 69.675 252.312-.002 69.677-69.675 69.677-182.638 0-252.312-69.674-69.677-182.636-69.677-252.31 0z",
    clipPath: "url(#SVGID_18_)",
    id: "path268"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M856.239 653.635c-53.025 53.024-53.025 138.993-.001 192.017s138.992 53.024 192.016-.002c53.024-53.022 53.024-138.991 0-192.015-53.024-53.024-138.992-53.024-192.015 0z",
    clipPath: "url(#SVGID_18_)",
    id: "path270",
    style: {
      clipPath: "url(#SVGID_18_)",
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g546",
    transform: "translate(-864 -322.322)"
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st751",
    d: "M1615.395 496.093a44.892 44.892 0 0 1-6.804.863l-.023.908c.426-.026.861-.039 1.301-.039 2.358 0 4.542.375 6.322 1.011a27.5 27.5 0 0 0-.796-2.743z",
    id: "path294"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st751",
    d: "m1592.883 376.917-.225.002c-.052.245-.107.49-.166.733l5.892.163.193-.371a30.79 30.79 0 0 0-5.694-.527z",
    id: "path296"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st752",
    d: "M1447.243 354.366c-24.174 0-43.772 19.598-43.772 43.772 0 15.932 8.511 29.875 21.235 37.531a32.628 32.628 0 0 1 2.642-2.734l-1.456-59.891 52.053 1.439a33.29 33.29 0 0 1-4.988-11.773 43.585 43.585 0 0 0-25.714-8.344z",
    id: "path298"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st752",
    d: "M1505.708 322.322c-18.484 0-33.467 14.984-33.467 33.467a33.31 33.31 0 0 0 5.704 18.695l52.02 1.439a32.225 32.225 0 0 1-.5-5.665c0-8.557 3.365-16.328 8.844-22.063-3.44-14.825-16.731-25.873-32.601-25.873z",
    id: "path300"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st752",
    d: "M1427.348 432.936a32.787 32.787 0 0 0-2.642 2.734 32.263 32.263 0 0 0-7.807 21.089 32.244 32.244 0 0 0 5.72 18.385 43.222 43.222 0 0 1 5.711-1.732z",
    id: "path302"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st752",
    d: "M1395.996 527.852c2.441 8.76 7.539 16.412 14.371 22.035a63.825 63.825 0 0 1-1.349-5.014c-1.822-8.111-3.666-13.201-5.262-16.394h-5.35a4.915 4.915 0 0 1-2.41-.627zm32.336-54.44a43.177 43.177 0 0 0-5.711 1.732c-16.501 6.269-28.227 22.23-28.227 40.931 0 1.46.072 2.906.211 4.33a4.922 4.922 0 0 1 3.8-1.787h27.497a6.872 6.872 0 0 1 3.254-11.29z",
    id: "path304"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st752",
    d: "M1646.831 527.721c-.76.48-1.661.758-2.626.758h-5.35c-1.596 3.193-3.441 8.283-5.263 16.394-3.95 17.586-17.081 37.675-30.318 48.292 1.877.245 3.791.371 5.734.371 24.174 0 43.771-19.597 43.771-43.771a43.57 43.57 0 0 0-5.948-22.044zm-13.237-14.174h-17.937a27.611 27.611 0 0 1-2.172 5.071h26.275a43.862 43.862 0 0 0-6.166-5.071zm-15.701-6.651c-.326.178-.677.346-1.049.501-.023.291-.05.581-.082.87h6.206a43.186 43.186 0 0 0-5.075-1.371z",
    id: "path306"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st753",
    d: "M1615.657 513.547h-7.497l-.132 5.071h5.457a27.543 27.543 0 0 0 2.172-5.071zm1.187-6.15c-.866.361-1.844.656-2.907.87h2.825c.032-.289.06-.578.082-.87z",
    id: "path308"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st752",
    d: "M1394.393 435.222c-7.006 0-12.687 5.68-12.687 12.687s5.681 12.687 12.687 12.687c7.006 0 12.687-5.68 12.687-12.687s-5.68-12.687-12.687-12.687z",
    id: "path310"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st752",
    d: "M1629.569 413.835a25.49 25.49 0 0 1-3.232.866c.871 3.216.788 6.531-.437 9.61.183.602.165 1.146-.054 1.632-.471 1.046-1.782 1.577-3.896 1.577-.925 0-1.994-.1-3.179-.29l-1.901 11.363a13.041 13.041 0 0 1 5.196 10.429c0 5.805-3.785 10.725-9.021 12.428l-4.069 24.315a27.766 27.766 0 0 1 6.42 10.328c20.41-4.197 35.757-22.264 35.757-43.916-.001-16.248-8.644-30.477-21.584-38.342z",
    id: "path312"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st753",
    d: "m1608.975 485.765-.11.657-.274 10.534a45.036 45.036 0 0 0 6.804-.863 27.774 27.774 0 0 0-6.42-10.328z",
    id: "path314"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st752",
    d: "M1443.511 485.131a8.872 8.872 0 1 1 8.871-8.871 8.87 8.87 0 0 1-8.871 8.871zm49.813-67.973c-5.271 0-9.544-4.273-9.544-9.545a9.544 9.544 0 0 1 9.544-9.544 9.543 9.543 0 0 1 9.544 9.544 9.544 9.544 0 0 1-9.544 9.545zm-67.431-44.113 1.456 59.891.984 40.476.825 33.915a6.87 6.87 0 0 1 6.851 11.29h31.709a9.449 9.449 0 0 1 9.396-10.377 9.452 9.452 0 0 1 3.404.636 9.458 9.458 0 0 1 8.496-5.334 9.477 9.477 0 0 1 3.64.732 5.242 5.242 0 0 1 4.532-2.622 5.23 5.23 0 0 1 5.17 6.042c.174-.02.348-.037.523-.048l22.066-25.089a8.51 8.51 0 0 1 4.485-5.1l23.005-26.156a8.872 8.872 0 1 1 9.687-11.014l9.251-10.518c-5.733-5.594-9.292-13.404-9.292-22.047 0-1.893.171-3.744.498-5.542a32.32 32.32 0 0 1-1.167.021c-15.709 0-28.77-11.34-31.444-26.279l-52.02-1.439z",
    id: "path316"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st753",
    d: "M1608.16 513.547h-3.834l-.839 5.014h-34.991c0 .018 0 .037.01.057h39.526l.131-5.071zm-2.93-5.404-.021.124h.592c-.193-.039-.384-.08-.571-.124zm3.635-21.721-1.943 11.605a20.826 20.826 0 0 1 1.645-.162l.023-.908z",
    id: "path318"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st753",
    d: "M1592.492 377.651c-3.248 13.713-15.338 24.006-29.917 24.53a30.934 30.934 0 0 0-.498 5.542c0 8.643 3.558 16.453 9.292 22.047l15.349-17.451c-2.139-1.99-3.206-3.812-2.59-5.177.225-.499.641-.882 1.244-1.144 2.311-4.165 6.579-6.939 11.662-7.993a25.681 25.681 0 0 1-1.446-8.521c0-4.202 1.009-8.168 2.796-11.67z",
    id: "path320"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st752",
    d: "M1561.409 338.315c-9.085 0-17.283 3.792-23.1 9.88-5.479 5.735-8.844 13.506-8.844 22.063 0 1.934.172 3.826.5 5.665 2.674 14.94 15.734 26.279 31.444 26.279.391 0 .779-.007 1.167-.021 2.597-14.296 15.062-25.155 30.082-25.263.455-2.148.695-4.376.695-6.661-.001-17.64-14.302-31.942-31.944-31.942z",
    id: "path322"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st753",
    d: "M1592.657 376.918c-15.02.108-27.485 10.967-30.082 25.263 14.578-.524 26.668-10.817 29.917-24.53.058-.243.113-.488.165-.733z",
    id: "path324"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st752",
    d: "M1621.3 363.774c-9.849 0-18.404 5.538-22.722 13.669 14.292 2.672 25.11 15.213 25.11 30.28 0 .402-.01.8-.022 1.198 1.227 1.837 2.132 3.79 2.672 5.781a25.49 25.49 0 0 0 3.232-.866c10.143-3.443 17.441-13.045 17.441-24.351-.001-14.2-11.512-25.711-25.711-25.711z",
    id: "path326"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st753",
    d: "M1598.578 377.443a25.602 25.602 0 0 0-2.989 12.041c0 2.986.51 5.854 1.446 8.521a23.258 23.258 0 0 1 4.739-.477c3.323 0 6.822.671 10.241 2.085 5.04 2.085 9.062 5.437 11.651 9.308.015-.398.022-.796.022-1.198 0-15.067-10.818-27.608-25.11-30.28z",
    id: "path328"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st752",
    d: "M1608.226 332.328c-7.578 0-13.721 6.144-13.721 13.721 0 7.579 6.143 13.722 13.721 13.722s13.721-6.143 13.721-13.722c-.001-7.577-6.144-13.721-13.721-13.721z",
    id: "path330"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st754",
    d: "M1622.065 449.022c0 7.217-5.849 13.066-13.067 13.066-7.216 0-13.065-5.849-13.065-13.066 0-7.215 5.849-13.065 13.065-13.065 7.217.001 13.067 5.85 13.067 13.065z",
    id: "path332"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st755",
    d: "M1619.655 453.738a18.833 18.833 0 0 1-5.764 2.65l-.649 3.874a11.442 11.442 0 0 0 6.413-6.524z",
    id: "path334"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1609.365 439.414c2.677.073 4.578 3.356 6.376 1.631 1.436-1.375-3.285-3.984-6.745-3.984-3.457 0-6.408 2.168-7.574 5.217 2.259-1.541 5.004-2.943 7.943-2.864z",
    id: "path336"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st754",
    d: "M1585.075 490.232a8.871 8.871 0 1 1-17.742 0 8.87 8.87 0 0 1 8.871-8.87 8.87 8.87 0 0 1 8.871 8.87z",
    id: "path338"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1576.454 483.709c1.818.05 3.108 2.278 4.329 1.107.975-.934-2.23-2.704-4.579-2.704a5.505 5.505 0 0 0-5.142 3.541c1.532-1.047 3.396-1.998 5.392-1.944z",
    id: "path340"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st754",
    d: "M1452.382 476.26a8.872 8.872 0 1 1-17.743-.001 8.872 8.872 0 0 1 17.743.001z",
    id: "path342"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st755",
    d: "M1450.746 479.461a12.773 12.773 0 0 1-7.587 2.229 12.768 12.768 0 0 1-6.883-2.226 7.742 7.742 0 0 0 14.47-.003z",
    id: "path344"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1443.76 469.737c1.818.05 3.108 2.278 4.329 1.107.976-.934-2.23-2.705-4.579-2.705a5.505 5.505 0 0 0-5.142 3.541c1.533-1.046 3.397-1.998 5.392-1.943z",
    id: "path346"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st754",
    d: "M1562.396 442.497c0 4.9-3.972 8.871-8.872 8.871a8.871 8.871 0 1 1 8.872-8.871z",
    id: "path348"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st755",
    d: "M1546.29 445.701a7.745 7.745 0 0 0 6.703 4.964l2.541-2.889a12.814 12.814 0 0 1-2.36.151 12.782 12.782 0 0 1-6.884-2.226z",
    id: "path350"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1553.774 435.973c1.817.051 3.108 2.279 4.33 1.107.975-.933-2.23-2.704-4.579-2.704a5.506 5.506 0 0 0-5.143 3.542c1.533-1.048 3.396-2 5.392-1.945z",
    id: "path352"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st754",
    d: "M1537.931 528.338a7.986 7.986 0 1 1-15.973.001 7.986 7.986 0 0 1 15.973-.001z",
    id: "path354"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1530.169 522.466c1.636.045 2.798 2.051 3.898.997.878-.841-2.008-2.434-4.123-2.434a4.955 4.955 0 0 0-4.628 3.188c1.378-.943 3.056-1.8 4.853-1.751z",
    id: "path356"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st754",
    d: "M1437.825 513.96a6.87 6.87 0 1 1-6.871-6.87 6.87 6.87 0 0 1 6.871 6.87z",
    id: "path358"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st755",
    d: "M1436.559 516.441a9.885 9.885 0 0 1-5.876 1.725 9.9 9.9 0 0 1-5.331-1.724 6.018 6.018 0 0 0 1.438 2.176h8.331a6.027 6.027 0 0 0 1.438-2.177z",
    id: "path360"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1431.148 508.907c1.407.038 2.407 1.765 3.354.858.754-.723-1.728-2.095-3.547-2.095a4.265 4.265 0 0 0-3.983 2.743c1.186-.811 2.63-1.548 4.176-1.506z",
    id: "path362"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st754",
    d: "M1573.287 422.478a7.645 7.645 0 1 1-15.291.001 7.645 7.645 0 0 1 15.291-.001z",
    id: "path364"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1565.857 416.857c1.566.043 2.678 1.963 3.731.954.841-.804-1.922-2.331-3.946-2.331a4.748 4.748 0 0 0-4.432 3.052c1.32-.902 2.926-1.722 4.647-1.675z",
    id: "path366"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st754",
    d: "M1502.868 407.614a9.544 9.544 0 0 1-9.544 9.545c-5.271 0-9.544-4.273-9.544-9.545a9.544 9.544 0 0 1 9.544-9.544 9.543 9.543 0 0 1 9.544 9.544z",
    id: "path368"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st755",
    d: "M1501.109 411.058a13.738 13.738 0 0 1-8.163 2.397 13.752 13.752 0 0 1-7.406-2.394 8.332 8.332 0 0 0 15.569-.003z",
    id: "path370"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1493.593 400.595c1.956.053 3.344 2.451 4.657 1.191 1.049-1.005-2.4-2.91-4.926-2.91a5.923 5.923 0 0 0-5.532 3.81c1.648-1.125 3.653-2.149 5.801-2.091z",
    id: "path372"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st754",
    d: "M1522.273 404.338a5.934 5.934 0 1 1-11.867 0 5.934 5.934 0 0 1 11.867 0z",
    id: "path374"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1516.507 399.975c1.215.034 2.078 1.524 2.896.741.652-.625-1.492-1.81-3.063-1.81-1.57 0-2.91.984-3.439 2.369 1.024-.7 2.27-1.336 3.606-1.3z",
    id: "path376"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st754",
    d: "M1489.703 393.161a4.36 4.36 0 1 1-8.721 0 4.36 4.36 0 1 1 8.721 0z",
    id: "path378"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1485.465 389.955c.893.025 1.528 1.121 2.128.544.479-.46-1.096-1.33-2.251-1.33a2.705 2.705 0 0 0-2.526 1.741c.752-.514 1.667-.982 2.649-.955z",
    id: "path380"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1518.744 509.923a9.408 9.408 0 0 0-3.622.721 5.232 5.232 0 0 0-10.268-.651 9.559 9.559 0 0 0-1.129-.07c-4.654 0-8.519 3.367-9.297 7.798a9.443 9.443 0 0 0-10.318 9.402c0 5.216 4.228 9.444 9.443 9.444a9.407 9.407 0 0 0 6.655-2.744 9.413 9.413 0 0 0 6.656 2.744c4.76 0 8.695-3.522 9.347-8.101a9.49 9.49 0 0 0 2.532.346c5.215 0 9.444-4.229 9.444-9.444 0-5.216-4.228-9.445-9.443-9.445z",
    id: "path382"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1559.15 517.378a9.396 9.396 0 0 0-3.682-.291 5.231 5.231 0 0 0-9.703-3.419 9.403 9.403 0 0 0-1.067-.374c-4.478-1.266-9.113.924-11.068 4.975a9.077 9.077 0 0 0-.83-.278 9.444 9.444 0 1 0-5.137 18.176 9.413 9.413 0 0 0 7.151-.83 9.419 9.419 0 0 0 5.658 4.451c4.581 1.294 9.325-1.025 11.198-5.255a9.418 9.418 0 0 0 2.342 1.022c5.019 1.419 10.238-1.499 11.658-6.52 1.417-5.02-1.501-10.238-6.52-11.657z",
    id: "path384"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1547.389 503.972a9.396 9.396 0 0 0-3.682-.292 5.232 5.232 0 0 0-9.703-3.419 9.81 9.81 0 0 0-1.067-.374c-4.478-1.266-9.113.924-11.068 4.975a9.443 9.443 0 0 0-12.486 6.241c-1.418 5.021 1.5 10.239 6.52 11.658a9.412 9.412 0 0 0 7.15-.832 9.419 9.419 0 0 0 5.658 4.452c4.581 1.294 9.326-1.025 11.199-5.255a9.478 9.478 0 0 0 2.342 1.023c5.019 1.419 10.239-1.5 11.656-6.52a9.444 9.444 0 0 0-6.519-11.657z",
    id: "path386"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1519.148 528.351a9.405 9.405 0 0 0-3.68-.292 5.232 5.232 0 0 0-9.704-3.419c-.345-.143-.7-.27-1.067-.373-4.479-1.266-9.113.923-11.068 4.975a9.443 9.443 0 0 0-12.486 6.242 9.443 9.443 0 0 0 6.52 11.656 9.418 9.418 0 0 0 7.151-.83 9.41 9.41 0 0 0 5.658 4.45c4.58 1.295 9.326-1.024 11.198-5.253a9.46 9.46 0 0 0 2.343 1.021c5.019 1.418 10.237-1.501 11.656-6.52 1.418-5.019-1.502-10.238-6.521-11.657z",
    id: "path388"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1506.035 507.985a9.391 9.391 0 0 0-3.682-.291 5.231 5.231 0 0 0-9.703-3.42 9.81 9.81 0 0 0-1.067-.374c-4.479-1.266-9.114.924-11.069 4.976a9.372 9.372 0 0 0-.829-.278c-5.02-1.418-10.239 1.5-11.658 6.519-1.418 5.02 1.501 10.239 6.52 11.658a9.418 9.418 0 0 0 7.151-.831 9.417 9.417 0 0 0 5.658 4.451c4.581 1.294 9.326-1.024 11.199-5.255a9.422 9.422 0 0 0 2.342 1.022c5.019 1.419 10.238-1.5 11.657-6.52a9.444 9.444 0 0 0-6.519-11.657z",
    id: "path390"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1559.176 476.414a8.505 8.505 0 0 0-3.325-.263 4.725 4.725 0 0 0-8.763-3.087 8.383 8.383 0 0 0-.964-.338c-4.044-1.144-8.23.834-9.996 4.493a8.53 8.53 0 0 0-11.276 5.636 8.528 8.528 0 0 0 5.888 10.527 8.499 8.499 0 0 0 6.458-.749 8.503 8.503 0 0 0 5.109 4.02c4.136 1.169 8.422-.925 10.114-4.746a8.53 8.53 0 0 0 12.642-4.965 8.528 8.528 0 0 0-5.887-10.528z",
    id: "path392"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st756",
    d: "M1399.08 523.101s5.046 0 9.937 21.772c5.157 22.952 25.946 50.162 42.205 55.022 16.259 4.861 123.906 4.861 140.166 0 16.258-4.86 37.047-32.07 42.204-55.022 4.891-21.772 9.936-21.772 9.936-21.772z",
    id: "path394"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st757",
    d: "M1649.135 523.547a4.93 4.93 0 0 1-4.931 4.931h-245.799a4.931 4.931 0 1 1 0-9.861h245.799a4.93 4.93 0 0 1 4.931 4.93z",
    id: "path396"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1515.878 577.043a5.81 5.81 0 1 1 .001-11.619 5.81 5.81 0 0 1-.001 11.619zm58.546-25.534a4.221 4.221 0 1 1 0-8.442 4.221 4.221 0 0 1 0 8.442zm-88.884 8.48a8.872 8.872 0 1 1 .001-17.743 8.872 8.872 0 0 1-.001 17.743zm125.983-31.51h-32.537a9.375 9.375 0 0 1-.318 3.439c-1.176 4.161-4.963 6.878-9.084 6.878-.85 0-1.715-.116-2.573-.359a9.4 9.4 0 0 1-2.342-1.021 9.453 9.453 0 0 1-8.625 5.612c-.85 0-1.715-.116-2.573-.359a9.414 9.414 0 0 1-5.659-4.451 9.423 9.423 0 0 1-7.151.832c-4.658-1.316-7.507-5.906-6.759-10.572h-102.817c.892 2.607 4.041 12.159 7.106 25.805 3.817 16.989 19.205 37.13 31.239 40.727 6.018 1.8 28.946 2.699 51.874 2.699 22.929 0 45.856-.899 51.874-2.699 12.035-3.597 27.423-23.738 31.239-40.727 3.066-13.645 6.214-23.197 7.106-25.804z",
    id: "path398",
    style: {
      fill: "#196175"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1534.045 527.763h-103.209s.087.244.249.716h102.817c.039-.239.086-.477.143-.716zm77.727 0h-32.88c.04.237.072.475.094.716h32.537c.162-.472.249-.716.249-.716z",
    id: "path400",
    style: {
      fill: "#80b3b6"
    }
  }), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st757",
    d: "M1494.411 551.117a8.872 8.872 0 1 1-17.744 0 8.872 8.872 0 0 1 17.744 0z",
    id: "path402"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st760",
    d: "M1492.775 554.319a12.763 12.763 0 0 1-7.587 2.228 12.773 12.773 0 0 1-6.883-2.225 7.743 7.743 0 0 0 14.47-.003z",
    id: "path404"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1485.79 544.594c1.817.051 3.108 2.279 4.329 1.108.975-.934-2.23-2.705-4.579-2.705a5.505 5.505 0 0 0-5.142 3.541c1.532-1.046 3.395-1.998 5.392-1.944z",
    id: "path406"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st757",
    d: "M1521.688 571.234a5.81 5.81 0 1 1-11.62 0 5.81 5.81 0 0 1 11.62 0z",
    id: "path408"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st760",
    d: "M1520.617 573.33a8.365 8.365 0 0 1-4.969 1.459 8.344 8.344 0 0 1-4.507-1.457 5.07 5.07 0 0 0 9.476-.002z",
    id: "path410"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1516.042 566.962c1.19.033 2.035 1.492 2.834.725.639-.611-1.46-1.772-2.998-1.772a3.605 3.605 0 0 0-3.367 2.32c1.004-.686 2.223-1.309 3.531-1.273z",
    id: "path412"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st757",
    d: "M1578.646 547.287a4.221 4.221 0 1 1-8.443 0 4.221 4.221 0 0 1 8.443 0z",
    id: "path414"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "st760",
    d: "M1577.868 548.811a6.08 6.08 0 0 1-3.44 1.062l-.171-.002a6.07 6.07 0 0 1-3.275-1.06 3.685 3.685 0 0 0 6.886 0z",
    id: "path416"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1574.543 544.183c.865.024 1.479 1.085 2.06.527.463-.444-1.062-1.287-2.18-1.287-1.116 0-2.07.701-2.447 1.685.731-.498 1.618-.951 2.567-.925z",
    id: "path418"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1564.821 518.56h-3.069c.029.018.057.036.085.057h3.015c-.011-.018-.021-.038-.031-.057z",
    id: "path420",
    style: {
      fill: "#e4f5f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1568.496 518.56h-3.675l.031.057h3.651c0-.019 0-.038-.01-.057z",
    id: "path422",
    style: {
      fill: "#e6f7f5"
    }
  }), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1561.752 518.56h-9.252l-.041.057h9.378c-.028-.02-.056-.038-.085-.057z",
    id: "path424"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1552.5 518.56h-4.022l-.057.057h4.038c.015-.019.028-.038.041-.057z",
    id: "path426"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "st760",
    d: "M1568.503 518.617h-20.082a9.395 9.395 0 0 0-1.794 2.535 9.351 9.351 0 0 0-3.401-.637 9.448 9.448 0 0 0-9.18 7.248h44.847a9.446 9.446 0 0 0-10.425-7.793c.071-.456.08-.91.035-1.353z",
    id: "path428"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1578.986 528.479h-45.084c-.748 4.666 2.101 9.256 6.759 10.572a9.423 9.423 0 0 0 7.151-.832 9.414 9.414 0 0 0 5.659 4.451 9.43 9.43 0 0 0 2.573.359 9.452 9.452 0 0 0 8.625-5.612 9.415 9.415 0 0 0 2.342 1.021 9.44 9.44 0 0 0 2.573.359c4.121 0 7.908-2.717 9.084-6.878a9.425 9.425 0 0 0 .318-3.44z",
    id: "path430",
    style: {
      fill: "#bad0d6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1578.892 527.763h-44.847a10.07 10.07 0 0 0-.143.716h45.084a9.467 9.467 0 0 0-.094-.716z",
    id: "path432",
    style: {
      fill: "#d9e8e9"
    }
  }), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "st765",
    d: "M1407.08 518.617s-11.257 44.74-.85 50.005c10.408 5.266 42.045 9.446 49.786 5.48 6.483-3.322 0-55.732 0-55.732z",
    id: "path434"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1439 563.934c-4.492 0-9.637-.43-15.34-1.593-10.951-2.232-21.731-6.973-21.841-7.02l-.01-1.297c.109.047 11.325 4.73 22.129 6.934 20.923 4.266 34.813-1.695 34.948-1.756l.016 1.287c-.416.188-7.542 3.445-19.906 3.445z",
    id: "path436"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1438.998 559.961c-4.491 0-9.636-.43-15.339-1.592-10.951-2.233-21.731-6.973-21.842-7.02l-.01-1.296c.109.047 11.325 4.73 22.129 6.933 20.923 4.266 34.813-1.694 34.948-1.755l.016 1.287c-.415.187-7.541 3.443-19.907 3.443z",
    id: "path438"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "st756",
    d: "M1650.893 396.085s-19.293-10.581-28.404-8.51c-9.111 2.072-13.398 12.776-13.398 12.776l3.646 2.555s1.556-12.187 12.579-12.723c11.023-.535 25.576 12.723 25.576 12.723v-6.821z",
    id: "path440"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "st756",
    d: "M1612.015 399.613c11.366 4.701 17.55 15.842 13.81 24.884l-41.163-17.025c3.74-9.042 15.985-12.56 27.353-7.859z",
    id: "path442"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "st766",
    d: "M1602.852 421.281c11.165 5.032 21.172 6.989 22.35 4.373 1.18-2.617-6.915-8.817-18.08-13.849s-21.172-6.99-22.351-4.373c-1.179 2.617 6.917 8.817 18.081 13.849z",
    id: "path444"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "st756",
    d: "M1621.95 427.52c-4.302 0-11.73-2.145-19.388-5.595-10.366-4.672-20.026-11.25-18.434-14.783.471-1.047 1.782-1.577 3.896-1.577 4.302 0 11.731 2.145 19.388 5.596 5.449 2.455 10.352 5.266 13.809 7.914 3.809 2.917 5.365 5.229 4.626 6.869-.472 1.045-1.783 1.576-3.897 1.576zm-33.926-20.542c-1.423 0-2.4.278-2.609.744-.771 1.71 5.601 7.451 17.726 12.917 7.487 3.374 14.694 5.47 18.808 5.47 1.424 0 2.4-.278 2.609-.744.302-.671-.616-2.426-4.196-5.169-3.373-2.584-8.178-5.335-13.53-7.747-7.488-3.375-14.695-5.471-18.808-5.471z",
    id: "path446"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "st756",
    d: "M1613.69 396.544c3.047 1.26 4.447 4.864 3.129 8.051l-11.029-4.561c1.318-3.187 4.855-4.75 7.9-3.49z",
    id: "path448"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "st756",
    d: "M1644.831 397.907c.017-3.297 2.827-5.953 6.275-5.935l-.063 11.935c-3.448-.018-6.229-2.704-6.212-6z",
    id: "path450"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "st756",
    d: "M1586.833 510.906a2.64 2.64 0 0 0 2.64 2.64h70.285a2.64 2.64 0 0 0 0-5.279h-70.285a2.64 2.64 0 0 0-2.64 2.639z",
    id: "path452"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "st765",
    d: "M1598.999 503.243c0 2.991 4.866 5.417 10.87 5.417 6.003 0 10.868-2.425 10.868-5.417 0-2.991-4.866-5.417-10.868-5.417-6.004 0-10.87 2.426-10.87 5.417z",
    id: "path454"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "st767",
    d: "M1613.044 461.451a13.018 13.018 0 0 1-3.546.629l-.613 23.594.09.092zm3.95-34.553a30.974 30.974 0 0 1-6.746 6.272l-.074 2.84a12.99 12.99 0 0 1 6.694 2.584l1.901-11.363a35.177 35.177 0 0 1-1.775-.333z",
    id: "path456"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "st768",
    d: "m1608.884 485.674-.019.749.11-.657a7.937 7.937 0 0 1-.091-.092z",
    id: "path458"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "st768",
    d: "m1610.459 425.054-.211 8.116a30.974 30.974 0 0 0 6.746-6.272c-1.974-.422-4.186-1.045-6.535-1.844z",
    id: "path460"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "st767",
    d: "m1571.369 429.77-9.251 10.518a8.871 8.871 0 0 1-9.686 11.014l-23.005 26.156a8.502 8.502 0 0 1 6.702-.239 8.541 8.541 0 0 1 7.673-4.816 8.535 8.535 0 0 1 3.287.661 4.733 4.733 0 0 1 4.092-2.37 4.725 4.725 0 0 1 4.671 5.456 8.514 8.514 0 0 1 3.325.263 8.53 8.53 0 1 1-6.755 15.492 8.538 8.538 0 0 1-7.79 5.069 8.535 8.535 0 0 1-2.323-.323 8.497 8.497 0 0 1-5.109-4.02 8.526 8.526 0 0 1-4.135 1.074 8.507 8.507 0 0 1-2.324-.325 8.529 8.529 0 0 1-5.798-10.824l-22.066 25.089a9.438 9.438 0 0 1 3.014.3 5.216 5.216 0 0 1 4.038-1.906c.829 0 1.612.192 2.309.535a9.462 9.462 0 0 1 6.227-2.349 9.398 9.398 0 0 1 3.404.637 9.456 9.456 0 0 1 8.496-5.334 9.465 9.465 0 0 1 3.639.732 5.237 5.237 0 0 1 5.958-2.424 5.232 5.232 0 0 1 3.745 5.843 9.443 9.443 0 0 1 3.681.291c4.096 1.157 6.794 4.846 6.876 8.892a5.249 5.249 0 0 1 1.248 2.962 9.443 9.443 0 0 1 3.252.725 5.237 5.237 0 0 1 4.047-2.599 27.755 27.755 0 0 1-1.402-8.735 27.637 27.637 0 0 1 6.332-17.649 8.88 8.88 0 0 1 7.031-6.09 27.625 27.625 0 0 1 14.397-4.021c7.709 0 14.685 3.144 19.715 8.217l.613-23.594c-.166.006-.333.009-.5.009-7.216 0-13.065-5.849-13.065-13.066 0-7.215 5.849-13.065 13.065-13.065.397 0 .789.018 1.177.052l.074-2.84a30.665 30.665 0 0 1-17.365 5.357c-8.371.002-15.962-3.337-21.514-8.755z",
    id: "path462"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "st768",
    d: "M1589.169 477.456a27.634 27.634 0 0 0-14.397 4.021 8.87 8.87 0 0 1 10.303 8.754 8.871 8.871 0 1 1-17.334-2.665 27.637 27.637 0 0 0-6.332 17.649c0 3.052.493 5.989 1.402 8.735a5.22 5.22 0 0 1 1.911.175 5.231 5.231 0 0 1 3.774 4.434h34.991l.839-5.014h-14.853a2.64 2.64 0 0 1 0-5.279h15.736l.021-.124c-3.683-.868-6.231-2.736-6.231-4.901 0-2.483 3.352-4.574 7.923-5.215l1.943-11.605.019-.749c-5.03-5.072-12.006-8.216-19.715-8.216z",
    id: "path464"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "st768",
    d: "m1586.718 412.319-15.349 17.451a30.704 30.704 0 0 0 21.513 8.757 30.662 30.662 0 0 0 17.365-5.357l.211-8.116a89.488 89.488 0 0 1-7.898-3.129c-6.357-2.866-12.449-6.449-15.842-9.606z",
    id: "path466"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "st769",
    d: "M1601.424 442.279a8.111 8.111 0 0 1 7.574-5.217c3.459 0 8.181 2.608 6.745 3.984-.374.358-.751.501-1.14.501-1.482 0-3.116-2.073-5.237-2.131a9.763 9.763 0 0 0-.242-.003c-2.849-.002-5.505 1.365-7.7 2.866zm7.573-6.321c-7.216 0-13.065 5.85-13.065 13.065 0 7.217 5.849 13.066 13.065 13.066a13.018 13.018 0 0 0 4.046-.638l.199-1.189a11.342 11.342 0 0 1-4.245.818c-4.866 0-9.018-3.048-10.655-7.338a18.81 18.81 0 0 0 10.667 3.286c1.687 0 3.323-.222 4.882-.639l2.977-17.795a13.003 13.003 0 0 0-7.871-2.636z",
    id: "path468"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "st770",
    d: "M1598.342 453.741c1.638 4.29 5.789 7.338 10.655 7.338 1.501 0 2.933-.29 4.245-.818l.649-3.874a18.867 18.867 0 0 1-5.411.632 18.8 18.8 0 0 1-10.138-3.278z",
    id: "path470"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1608.997 437.062c-3.457 0-6.408 2.168-7.574 5.217 2.195-1.501 4.851-2.868 7.7-2.868l.242.003c2.121.058 3.755 2.131 5.237 2.131.388 0 .765-.142 1.14-.501 1.436-1.374-3.285-3.982-6.745-3.982z",
    id: "path472"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "st769",
    d: "M1583.44 493.433a7.744 7.744 0 0 1-14.47.002 12.767 12.767 0 0 0 7.242 2.231 12.744 12.744 0 0 0 7.228-2.233zm-12.378-7.78a5.506 5.506 0 0 1 5.142-3.541c2.348 0 5.554 1.77 4.579 2.704-.254.243-.51.34-.774.34-1.006 0-2.115-1.407-3.555-1.447-.055-.002-.108-.002-.162-.002-1.935 0-3.739.928-5.23 1.946zm5.142-4.291a8.88 8.88 0 0 0-8.463 6.206 8.872 8.872 0 1 0 8.463-6.206z",
    id: "path474"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "st770",
    d: "M1583.44 493.433a12.76 12.76 0 0 1-7.588 2.229 12.764 12.764 0 0 1-6.882-2.226 7.744 7.744 0 0 0 14.47-.003z",
    id: "path476"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1576.204 482.112a5.505 5.505 0 0 0-5.142 3.541c1.491-1.018 3.295-1.947 5.23-1.947l.162.002c1.44.04 2.549 1.447 3.555 1.447.264 0 .52-.096.774-.34.976-.933-2.23-2.703-4.579-2.703z",
    id: "path478"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "st769",
    d: "m1562.119 440.288-6.585 7.487a12.773 12.773 0 0 0 5.226-2.077 7.745 7.745 0 0 1-7.767 4.967l-.56.637a8.871 8.871 0 0 0 9.686-11.014z",
    id: "path480"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "st770",
    d: "M1560.76 445.698a12.76 12.76 0 0 1-5.226 2.077l-2.541 2.889a7.744 7.744 0 0 0 7.767-4.966z",
    id: "path482"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1509.929 506.04a5.216 5.216 0 0 0-4.038 1.906l.144.039a9.426 9.426 0 0 1 3.722 2.041 9.385 9.385 0 0 1 2.48-3.451 5.205 5.205 0 0 0-2.308-.535z",
    id: "path484"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1554.265 512.864a9.428 9.428 0 0 1-.441 3.046 9.375 9.375 0 0 1 1.689-.084 5.263 5.263 0 0 0-1.248-2.962z",
    id: "path486"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1538.536 497.64a5.237 5.237 0 0 0-4.532 2.622 9.465 9.465 0 0 0-3.639-.732 9.454 9.454 0 0 0-8.496 5.334 9.398 9.398 0 0 0-3.404-.637 9.457 9.457 0 0 0-6.227 2.349 9.385 9.385 0 0 0-2.48 3.451 9.456 9.456 0 0 1 3.037 8.534h35.684a9.47 9.47 0 0 1 5.346-2.651 9.461 9.461 0 0 0 .441-3.046c-.082-4.046-2.78-7.735-6.876-8.892a9.454 9.454 0 0 0-3.681-.291 5.232 5.232 0 0 0-5.173-6.041z",
    id: "path488"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1503.466 507.628c-.197 0-.394.006-.589.018l-9.599 10.914h19.517a9.453 9.453 0 0 0-3.037-8.534 9.408 9.408 0 0 0-3.722-2.041l-.144-.039a9.408 9.408 0 0 0-2.426-.318z",
    id: "path490"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1551.181 470.694a4.731 4.731 0 0 0-4.092 2.37 8.525 8.525 0 0 0-3.287-.661 8.541 8.541 0 0 0-7.673 4.816 8.576 8.576 0 0 0-3.073-.575c-1.273 0-2.51.286-3.629.814l-4.485 5.1a8.528 8.528 0 0 0 5.798 10.824c.775.22 1.556.325 2.324.325a8.53 8.53 0 0 0 4.135-1.074 8.503 8.503 0 0 0 5.109 4.02 8.535 8.535 0 0 0 2.323.323 8.537 8.537 0 0 0 7.79-5.069 8.493 8.493 0 0 0 2.115.923c.775.22 1.556.324 2.325.324a8.53 8.53 0 1 0-1.01-17.002 4.725 4.725 0 0 0-3.383-5.276 4.668 4.668 0 0 0-1.287-.182z",
    id: "path492"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1562.811 513.951a5.24 5.24 0 0 0-4.047 2.599 9.506 9.506 0 0 0-3.252-.725c.036.414.022.836-.045 1.261a9.522 9.522 0 0 1 1.111-.067c.849 0 1.712.116 2.571.358.947.268 1.82.671 2.602 1.182h3.069a27.68 27.68 0 0 1-2.009-4.608z",
    id: "path494",
    style: {
      fill: "#eff9f8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1563.297 513.928a5.22 5.22 0 0 0-.486.023 27.648 27.648 0 0 0 2.01 4.609h3.675a5.23 5.23 0 0 0-5.199-4.632z",
    id: "path496",
    style: {
      fill: "#f0faf9"
    }
  }), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1555.125 515.819c-.438 0-.873.031-1.301.091a9.381 9.381 0 0 1-1.324 2.651h9.252a9.47 9.47 0 0 0-6.284-1.473c.067-.425.08-.847.045-1.261a8.428 8.428 0 0 0-.388-.008z",
    id: "path498"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1553.824 515.91a9.473 9.473 0 0 0-5.346 2.651h4.022a9.434 9.434 0 0 0 1.324-2.651z",
    id: "path500"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m1589.981 408.608-2.337 2.658c2.788 2.566 8.06 6.021 15.497 9.373 5.928 2.671 11.681 4.542 15.861 5.205l.53-3.169z",
    id: "path502",
    style: {
      fill: "#dde2ef"
    }
  }), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "st774",
    d: "m1587.644 411.265-.926 1.054c3.393 3.157 9.485 6.74 15.843 9.606a89.488 89.488 0 0 0 7.898 3.129c2.349.798 4.561 1.422 6.535 1.843.616.132 1.21.243 1.776.333l.232-1.387c-4.18-.664-9.932-2.534-15.861-5.205-7.436-3.352-12.709-6.807-15.497-9.373z",
    id: "path504"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "st774",
    d: "M1605.209 508.267h-15.736a2.64 2.64 0 1 0 0 5.279h14.853z",
    id: "path506"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1606.923 498.028c-4.572.641-7.923 2.732-7.923 5.215 0 2.165 2.548 4.033 6.231 4.901z",
    id: "path508",
    style: {
      fill: "#f297b2"
    }
  }), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "st766",
    d: "M1596.14 415.093c-.057.133-.571.04-1.149-.209-.578-.248-1-.557-.944-.69.057-.133.573-.039 1.15.209.579.248 1 .557.943.69z",
    id: "path510"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "st776",
    d: "M1595.968 415.859c-.448 0-1.028-.228-1.257-.326-1.123-.482-1.565-1.026-1.314-1.615.064-.149.271-.49.822-.49.448 0 1.028.228 1.257.326 1.123.482 1.565 1.026 1.313 1.615-.063.148-.268.49-.821.49z",
    id: "path512"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "st766",
    d: "M1602.035 412.934c-.057.132-.572.04-1.15-.209-.578-.248-1.001-.557-.944-.69.057-.133.573-.04 1.15.208.578.248 1 .558.944.691z",
    id: "path514"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "st776",
    d: "M1601.862 413.7c-.448 0-1.028-.228-1.257-.326-.731-.314-1.174-.654-1.317-1.012a.804.804 0 0 1 0-.606c.062-.145.268-.486.82-.486.448 0 1.027.228 1.256.326 1.124.483 1.566 1.027 1.313 1.617-.062.145-.268.487-.82.487z",
    id: "path516"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "st766",
    d: "M1613.751 423.466c-.057.133-.571.04-1.15-.209-.577-.247-1-.557-.943-.69.057-.133.572-.039 1.151.209.578.247 1 .557.942.69z",
    id: "path518"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "st776",
    d: "M1613.579 424.232c-.448 0-1.028-.228-1.256-.327a4.488 4.488 0 0 1-.848-.467c-.635-.465-.564-.92-.465-1.15.062-.147.269-.488.821-.488.431 0 .972.205 1.256.326.731.313 1.174.654 1.316 1.012a.807.807 0 0 1 0 .607c-.061.145-.267.487-.82.487z",
    id: "path520"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "st766",
    d: "M1620.386 422.642c-.058.133-.573.039-1.151-.209-.578-.248-1.001-.557-.943-.689.057-.133.572-.04 1.15.208.579.248 1.001.557.944.69z",
    id: "path522"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "st776",
    d: "M1620.214 423.409c-.448 0-1.028-.229-1.257-.327-.733-.315-1.176-.655-1.318-1.013a.768.768 0 0 1 .01-.606c.061-.143.266-.485.819-.485.448 0 1.027.228 1.256.326 1.123.484 1.566 1.027 1.314 1.617-.063.147-.269.488-.82.488z",
    id: "path524"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "st766",
    d: "M1592.075 409.507c-.057.133-.572.04-1.15-.208-.578-.249-1.001-.558-.944-.691.057-.133.572-.039 1.151.209.578.248 1 .557.943.69z",
    id: "path526"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "st776",
    d: "M1591.903 410.273c-.449 0-1.028-.228-1.257-.326-.732-.315-1.176-.654-1.318-1.012a.766.766 0 0 1 .01-.607c.062-.144.268-.485.82-.485.448 0 1.027.228 1.256.326 1.124.482 1.566 1.026 1.314 1.617-.063.147-.269.487-.82.487z",
    id: "path528"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "st766",
    d: "M1605.189 419.368c-.057.132-.572.039-1.15-.21-.579-.248-1.001-.557-.944-.689.057-.133.572-.04 1.15.208.579.248 1.001.557.944.691z",
    id: "path530"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "st776",
    d: "M1605.016 420.134c-.448 0-1.028-.228-1.256-.326-.732-.315-1.175-.655-1.317-1.012a.77.77 0 0 1 .01-.607c.064-.147.27-.486.82-.486.447 0 1.027.228 1.255.326.733.315 1.176.656 1.317 1.013.08.2.078.415 0 .606-.061.143-.266.486-.82.486z",
    id: "path532"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "st766",
    d: "M1611.976 417.516c-.057.133-.572.04-1.151-.208-.577-.249-.999-.558-.943-.691.057-.133.572-.04 1.151.209.577.248.999.557.943.69z",
    id: "path534"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "st776",
    d: "M1611.804 418.282c-.448 0-1.028-.228-1.257-.326-1.124-.483-1.567-1.027-1.314-1.617.065-.149.272-.488.822-.488.447 0 1.028.228 1.256.326 1.124.483 1.567 1.026 1.314 1.617-.064.148-.27.488-.821.488z",
    id: "path536"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "st756",
    d: "M1444.868 607.434c2.378-.305 3.607.866 3.607.866s-3.993-8.647-3.186-9.891c.877-1.347 4.796-3.647 9.344-3.096 4.244.514 6.824 3.053 6.824 3.825 0 1.543-1.543 7.716-2.829 10.675-1.265 2.907-2.153 3.748-3.531 5.173-1.186 1.227-2.813 1.052-7.159 1.405-2.686.22-6.768-.975-6.768-.975-1.671-1.415-3.89-7.018 3.698-7.982z",
    id: "path538"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "st757",
    d: "M1444.257 608.31c1.964-.252 5.292.714 5.292.714s-3.295-9.449-2.629-10.477c.722-1.112 3.956-3.009 7.71-2.553 3.501.423 4.089 2.518 4.089 3.155 0 1.274-2.045 8.682-3.106 11.123-1.043 2.401-1.776 3.094-2.913 4.271-.979 1.011-.01.866-3.593 1.159-2.215.18-7.128-.806-7.128-.806-1.38-1.167-3.983-5.791 2.278-6.586z",
    id: "path540"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "st756",
    d: "M1596.029 607.432c-2.379-.301-3.608.868-3.608.868s3.993-8.647 3.186-9.891c-.876-1.347-4.795-3.647-9.344-3.096-4.244.514-6.824 3.053-6.824 3.825 0 1.543 1.543 7.716 2.829 10.675 1.264 2.907 2.152 3.75 3.53 5.173 1.187 1.227 2.813 1.052 7.159 1.405 2.686.218 6.769-.976 6.769-.976 1.672-1.414 3.891-7.017-3.697-7.983z",
    id: "path542"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "st757",
    d: "M1597.186 608.31c-1.963-.252-5.291.714-5.291.714s3.294-9.45 2.628-10.477c-.723-1.112-3.956-3.009-7.71-2.553-3.502.423-4.088 2.518-4.088 3.155 0 1.274 2.046 8.682 3.105 11.123 1.045 2.401 1.778 3.094 2.914 4.271.979 1.011.01.866 3.594 1.159 2.215.18 7.128-.806 7.128-.806 1.379-1.167 3.982-5.791-2.28-6.586z",
    id: "path544"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg002TotalWater);
export default __webpack_public_path__ + "static/media/002-TotalWater.584d6d9c7c3952641f357b0921578c9e.svg";
export { ForwardRef as ReactComponent };